import request from "../utils/request";

export const getDealers = '/dealer/'
export const getDealerList = '/dealer/dict';
export const getConfirmedDealerList = '/dealer/dict';

export const getDealerCreditStatisticsList = '/dealer/dealerCreditStatistics'

export function getLicenses() {
    return request.request({
        url: '/dealer/license',
        method: 'get'
    })
}

export function getDealer(dealerId?: string) {
    return request.request({
        url: '/dealer/detail',
        method: 'get',
        params: {dealerId}
    })
}

export function addDealer(data: any) {
    return request.request({
        url: '/dealer/',
        method: 'post',
        data: data
    })
}

export function editDealer(data: any) {
    return request.request({
        url: '/dealer/',
        method: 'put',
        data: data
    })
}

export function alterDealer(data: any) {
    return request.request({
        url: '/dealer/alter',
        method: 'put',
        data: data
    })
}


export function editDealerVersion(data: any) {
    return request.request({
        url: '/dealer/version',
        method: 'put',
        data: data
    })
}

export function getDealerVersions(dealerId: string) {
    return request.request({
        url: '/dealer/version',
        method: 'get',
        params: {dealerId}
    })
}

export function getDealerVersion(versionId: string) {
    return request.request({
        url: '/dealer/version/detail',
        method: 'get',
        params: {versionId}
    })
}

export const getDealerShippingListUrl = '/dealer/shipping';

export function getDealerShippingList() {
    return request.get('/dealer/shipping');
}

export function submitDealerToOA(dealerId: string) {
    return request.request({
        url: '/dealer/oa',
        method: 'post',
        data: {dealerId}
    })
}

export function submitDealerToERP(dealerId: string) {
    return request.request({
        url: '/dealer/erp',
        method: 'post',
        data: {dealerId}
    })
}

export function importDealers(file: File) {
    const formData = new FormData()
    formData.append("file", file)
    return request.request({
        url: '/dealer/import',
        method: 'post',
        data: formData
    })
}

export function synYunyigou(ids: Array<any>) {
    return request.put("/dealer/setSync", ids);
}

export function toggleDealerStatus(dealerId: number, status: number) {
    return request.request({
        url: '/dealer/status',
        method: 'put',
        data: {dealerId, status}
    })
}

export function completeDealer(dealerId: number) {
    return request.request({
        url: '/dealer/complete',
        method: 'post',
        data: {dealerId}
    })
}


export function deleteDealerVersion(versionId: string) {
    return request.request({
        url: '/dealer/version',
        method: 'delete',
        params: {versionId}
    })
}
